import { AfterViewInit, Component } from '@angular/core';
@Component({
  template:
    '<div id="jaas-container" style="width: 1000px; height: 700px; margin: 0 auto; padding: 1rem;"></div>',
})
export class VideoCallClientComponent implements AfterViewInit {
  private api;
  private TOOLBAR_BUTTONS: [
    'microphone',
    'camera',
    'desktop',
    'fullscreen',
    'fodeviceselection',
    'hangup',
    'profile',
    'chat',
    'recording',
    'settings',
    'videoquality',
    'filmstrip',
    'invite',
    'stats',
    'shortcuts',
    'tileview',
    'videobackgroundblur',
    'help',
    'mute-everyone',
    'security'
  ];

  constructor() {}

  ngAfterViewInit() {
    const api = new JitsiIframeAPI('8x8.vc', {
      roomName: 'vpaas-magic-cookie-60959015a0da42cd8bfd05877177df40/roomA',
      parentNode: document.getElementById('jaas-container'),
      jwt:
        'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InZwYWFzLW1hZ2ljLWNvb2tpZS02MDk1OTAxNWEwZGE0MmNkOGJmZDA1ODc3MTc3ZGY0MC80YTIwNDkifQ.eyJhdWQiOiJqaXRzaSIsImlzcyI6ImNoYXQiLCJzdWIiOiJ2cGFhcy1tYWdpYy1jb29raWUtNjA5NTkwMTVhMGRhNDJjZDhiZmQwNTg3NzE3N2RmNDAiLCJyb29tIjoicm9vbUEiLCJjb250ZXh0Ijp7ImZlYXR1cmVzIjp7ImxpdmVzdHJlYW1pbmciOmZhbHNlLCJvdXRib3VuZC1jYWxsIjpmYWxzZSwidHJhbnNjcmlwdGlvbiI6ZmFsc2UsInJlY29yZGluZyI6ZmFsc2V9LCJ1c2VyIjp7Im5hbWUiOiJDbGllbnQiLCJtb2RlcmF0b3IiOmZhbHNlLCJpZCI6Imdvb2dsZS1vYXV0aDJ8MTExOTM0NTg2NTM2OTQxNDUyOTA0IiwiYXZhdGFyIjoiIn19LCJpYXQiOjE2MTA2OTY1Mzh9.gXwmRJL7aO4oxiLlcX7hEN6gYLgJjU35OaAwStNeNuLMBBzboz4NsVXs1dP3U4FtiQxRuvVptD39HNgWyUJ_8HQqIOIQIhdKfmGqc7WKWaYBhXzhNSLbFPEJOmAoaZIL-tKsDSpIe7YqZC7veMMTmj1x96_MrQ3-DMYY4ccZB67TqmoO4FeueDxy2C3UAiqHsZnXWs3XTDGKU_CwNN4Oq_KSM4OFUqYgMxDXUnbItRbdEiHsJHBz19JFw7TgX_fMqqHVAsm577_oo8giKOHbZx30KlBNKqLZ72z2BkAMILNdF_14Obtw5BoxXI93mN_IXua8ZqSj26Gh1tLtAGp1cl37cvwq0fW_tpaFoPhAuZGQmFL0cCSW_8WaoqAm1w8DANKEwgxmKBg1xA794pBEw0EmNmAyxqIwqER57MXwrQ_2Ombu1CvT6UQMIA6VDCIe57CgbdYyCe2b3Ee-RNV99S8MmcmG-B1sE8pVPmXXLMmAok0ZAx7qc75J6623hHdUHRo4mU1IRm4Tl_bamKzerAV0_HGV3iszyGDiLYzhtYWDzOpD9rlFLogQGYMQMPoYDhwh3OVC7LTIsJbSFyZgGo5dKgzZFSALMqcuwB-bp8EzLdo9UbEgVGCt85WwGLRTLHHhzZpkgbfgKlLKYCJY8BwlyKjs29znLnRuUa_956I',
      interfaceConfigOverwrite: {
        TOOLBAR_BUTTONS: this.TOOLBAR_BUTTONS,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/video-call/video-call-client.component.ts